export default function () {

    function initCatalog() {
        let catalogGrid = document.getElementsByClassName('catalog-grid')[0];
        let listViewBtn = document.getElementsByClassName('js-list-view');
        let blockViewBtn = document.getElementsByClassName('js-block-view');
        let itemPicsSliders = document.getElementsByClassName('js-item-tile-slider');

        if(catalogGrid) {
            Array.from(listViewBtn).forEach(button => button.addEventListener('click', function (e) {

                blockViewBtn.forEach(function (btn) {
                    btn.classList.remove('is-active');
                });

                listViewBtn.forEach(function (btn) {
                    btn.classList.add('is-active');
                });

                document.body.classList.add('no-transition');
                catalogGrid.classList.add('list-view');

                Array.from(itemPicsSliders).forEach(function (slider) {
                    slider.swiper.update();
                });

                setTimeout(function () {
                    document.body.classList.remove('no-transition');
                }, 400);

                e.preventDefault();
            }));


            Array.from(blockViewBtn).forEach(button => button.addEventListener('click', function (e) {

                listViewBtn.forEach(function (btn) {
                    btn.classList.remove('is-active');
                });

                blockViewBtn.forEach(function (btn) {
                    btn.classList.add('is-active');
                });

                document.body.classList.add('no-transition');
                catalogGrid.classList.remove('list-view');

                Array.from(itemPicsSliders).forEach(function (slider) {
                    slider.swiper.update();
                });

                setTimeout(function () {
                    document.body.classList.remove('no-transition');
                }, 400);

                e.preventDefault();
            }));

        }
    }

    initCatalog();

}
